import { useEffect, useState } from "react";
import { Eye, EyeOff, Copy, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { staffApi, errMsg } from "@/lib/api";

export const StaffPasscodeCard = ({ isSuper }) => {
  const [code, setCode] = useState("");
  const [show, setShow] = useState(false);
  const [next, setNext] = useState("");
  useEffect(() => { staffApi().get("/settings/staff-passcode").then((r) => setCode(r.data.passcode)).catch(() => {}); }, []);
  const copy = async () => { try { await navigator.clipboard.writeText(code); toast.success("Staff passcode copied"); } catch (e) { toast.error("Could not copy"); } };
  const save = async () => {
    if (/\s/.test(next.trim())) return toast.error("Passcode must be 8+ characters with no spaces");
    try { await staffApi().put("/settings/staff-passcode", { passcode: next.trim() }); setCode(next.trim()); setNext(""); toast.success("Staff passcode changed. Share the new one with your team."); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-5" data-testid="staff-passcode-card">
      <div className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#1D64B4]" /><h3 className="font-semibold text-slate-900">Staff passcode</h3></div>
      <p className="mt-1 text-sm text-slate-500">Pastors, staff and leaders use this shared code to open the Staff Hub (view-only calendar, devotional uploads) and the iPhone recording page.</p>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <code className="rounded-xl bg-slate-100 px-4 py-2 font-mono text-base text-slate-900" data-testid="staff-passcode-value">{show ? code : "\u2022".repeat(Math.max(code.length, 8))}</code>
        <Button size="sm" variant="outline" onClick={() => setShow(!show)} data-testid="staff-passcode-toggle">{show ? <EyeOff className="mr-1 h-4 w-4" /> : <Eye className="mr-1 h-4 w-4" />}{show ? "Hide" : "Show"}</Button>
        <Button size="sm" variant="outline" onClick={copy} disabled={!code} data-testid="staff-passcode-copy"><Copy className="mr-1 h-4 w-4" /> Copy</Button>
      </div>
      {isSuper && (
        <div className="mt-3 flex flex-wrap gap-2">
          <Input value={next} onChange={(e) => setNext(e.target.value)} placeholder="New passcode (8+ chars)" className="max-w-xs" data-testid="staff-passcode-new-input" />
          <Button size="sm" disabled={next.trim().length < 8} onClick={save} className="rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4]" data-testid="staff-passcode-save">Change passcode</Button>
        </div>
      )}
    </div>
  );
};
